import React, { Component } from "react";
import Service from "../../../services";
import { catchError } from "../../../utils/Utils";
import { AxiosError, AxiosResponse } from "axios";
import { Container, Row } from "reactstrap";
import { QuickLinksFC } from "./QuickLinksFC";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import "./QuickLinks.scss";
import { BankUserContext } from "../../../bankUserContext";

interface PortalPageState {
  cardData: any;
}

export default class QuickLinks extends Component<
  unknown,
  PortalPageState
> {
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  constructor(props: unknown) {
    super(props);
    this.state = {
      cardData: null,
    };
  }

  service = new Service();

  componentDidMount() {
    this.getShortcutDetails();
  }

  getShortcutDetails() {
    if(this.context?.bankuserDetails){
    const quickLinkCards = {
      screen: "LandingPage",    
      sections: "getUserQuickLinks",    
      userId: this.context?.bankuserDetails.userId,
      "isJsonReturnObject":true
    };
  
    return this.service
    .getUserShortcutsByUserId(quickLinkCards)
    .then((response: AxiosResponse) => {
        this.setState({ cardData: response?.data });
    })
    .catch((error:AxiosError) => {
        catchError(error, true)
    });
  }
  }

  render() {
    return (
      <Container fluid>
        <Row className="bottomSection">
          <div>
            <DndProvider backend={HTML5Backend}>
              <QuickLinksFC cardData={this.state.cardData} />
            </DndProvider>
          </div>
        </Row>
      </Container>
    );
  }
}
